/*
 * @ Author: wangjiyu
 * @Date: 2019-12-05 14:07:57
 * @LastEditTime: 2020-05-08 10:01:57
 * @LastEditors: wangjiyu
 * @Description: file content
 */
import { IPostItem, IAction } from '../../interface';
import ActionType from '../../action/ActionType';

const contentState = [
    {
        type: 'text',
        value: '',
        desc: ''
    }
];
/* const contentState = [
    {
        type: 'text',
        value: '',
        desc: '',
    },
    {
        type: 'image',
        value:
            'http://n1-q.mafengwo.net/s16/M00/76/E7/CoUBUl6MToeANuvcAAIp8GDVCHU001.jpg?imageView2%2F2%2Fw%2F680%2Fq%2F90%7CimageMogr2%2Fstrip%2Fquality%2F90',
        desc: '这是马蜂窝的图片',
    },
    {
        type: 'text',
        value: '',
        desc: '',
    },
    {
        type: 'video',
        value:
            'http://n1-q.mafengwo.net/s16/M00/76/E7/CoUBUl6MToeANuvcAAIp8GDVCHU001.jpg?imageView2%2F2%2Fw%2F680%2Fq%2F90%7CimageMogr2%2Fstrip%2Fquality%2F90',
        desc: '这是马蜂窝的图片',
        videoSurface:
            'http://ikkf7jf9fbx5dvkakyu.exp.bcevod.com/mda-kd8r1g8s1g004ch9/mda-kd8r1g8s1g004ch9.jpg',
    },
    {
        type: 'text',
        value: '',
        desc: '',
    },
    {
        type: 'title',
        value: '这是一个标题',
    },
    {
        type: 'text',
        value: '',
        desc: '',
    },
]; */

const content = (state: IPostItem[] = contentState, action: IAction) => {
    switch (action.type) {
        case ActionType.PostSetContent:
            return action.payload;
        case ActionType.PostSetContentByIndex: {
            const copyState = state.slice();
            copyState[action.payload.index] = action.payload.item;
            return copyState;
        }
        case ActionType.PostInsertContentByIndex: {
            const copyState = state.slice();
            const textInput = {
                type: 'text',
                value: ''
            };
            if (
                !copyState[action.payload.index] ||
                !copyState[action.payload.index].type ||
                copyState[action.payload.index].type === 'text'
            ) {
                copyState.splice(
                    action.payload.index + 1,
                    0,
                    action.payload.item,
                    textInput
                );
            } else {
                copyState.splice(
                    action.payload.index + 1,
                    0,
                    textInput,
                    action.payload.item
                );
            }

            return copyState;
        }
        case ActionType.PostInsertTitleByIndex: {
            const copyState = state.slice();
            const textInput = {
                type: 'text',
                value: ''
            };
            if (
                copyState[action.payload.index] &&
                copyState[action.payload.index].type === 'text'
            ) {
                // 当前为input
                if (
                    copyState[action.payload.index + 1] &&
                    copyState[action.payload.index + 1].type === 'text'
                ) {
                    // 下方有input内容
                    copyState.splice(
                        action.payload.index + 1,
                        0,
                        action.payload.item
                    );
                } else {
                    // 下方无Input内容
                    copyState.splice(
                        action.payload.index + 1,
                        0,
                        action.payload.item,
                        textInput
                    );
                }
            } else {
                // 当前非input
                if (
                    copyState[action.payload.index + 1] &&
                    copyState[action.payload.index + 1].type === 'text'
                ) {
                    // 下方有input内容
                    copyState.splice(
                        action.payload.index + 1,
                        0,
                        textInput,
                        action.payload.item
                    );
                } else {
                    // 下方无Input内容
                    copyState.splice(
                        action.payload.index + 1,
                        0,
                        textInput,
                        action.payload.item,
                        textInput
                    );
                }
            }
            return copyState;
        }
        case ActionType.PostEditTitleByIndex: {
            const copyState = state.slice();
            if (
                copyState[action.payload.index] &&
                copyState[action.payload.index].type === 'title'
            ) {
                copyState.splice(action.payload.index, 1, action.payload.item);
            }
            return copyState;
        }
        case ActionType.PostRemoveContentByIndex: {
            const itemState = JSON.stringify(state);
            const copyState = JSON.parse(itemState).slice();
            console.log(
                'copyState[action.payload.index - 1]',
                copyState[action.payload.index + 1]
            );
            const preCon = copyState[action.payload.index - 1].value || '';
            let nextCon = '';
            if (copyState[action.payload.index + 1]) {
                nextCon =
                    (copyState[action.payload.index + 1] &&
                        copyState[action.payload.index + 1].value) ||
                    '';
            }
            if (preCon.length > 0 && nextCon.length > 0) {
                copyState[
                    action.payload.index - 1
                ].value = `${preCon}\n${nextCon}`;
            } else {
                copyState[action.payload.index - 1].value = preCon + nextCon;
            }
            copyState.splice(action.payload.index, 2);
            return copyState;
        }
        default:
            return state;
    }
};

export default content;
